import {createSlice, Dictionary, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, getContext, call, put} from 'typed-redux-saga'
import Api from '../../api/reactpt'
import {DataState} from '../../types/dataState.type'
import _ from 'lodash'
import BodyArea from 'src/models/BodyArea'
import {shouldLogUserOut} from '../configureStore'

export type BodyAreasState = {
  bodyAreas: Dictionary<BodyArea>
  dataState: DataState
}

const initialState: BodyAreasState = {
  bodyAreas: {},
  dataState: {state: 'unloaded'},
}

export const {actions, reducer} = createSlice({
  name: 'BodyAreas',
  initialState,
  reducers: {
    getBodyAreas: (_state: BodyAreasState, _action: PayloadAction<void>) => {},
    setBodyAreas: (state: BodyAreasState, action: PayloadAction<{bodyAreas: BodyArea[]}>) => {
      const keyed = _.keyBy(action.payload.bodyAreas, ({id}) => id)
      const newBodyAreas = {...keyed} as Dictionary<BodyArea>
      return {...state, bodyAreas: newBodyAreas}
    },
    setDataState: (state: BodyAreasState, action: PayloadAction<{dataState: DataState}>) => {
      const {dataState} = action.payload
      return {...state, dataState}
    },
    clear: (_state: BodyAreasState) => {
      return {...initialState}
    },
  },
})

export const getBodyAreasSaga = function* () {
  const api: Api = yield* getContext<Api>('api')
  yield* put(actions.setDataState({dataState: {state: 'loading'}}))
  try {
    const result = yield* call(api.getBodyAreas)
    yield* put(actions.setBodyAreas({bodyAreas: result}))
    yield* put(actions.setDataState({dataState: {state: 'loaded'}}))
  } catch (error) {
    if (shouldLogUserOut(error)) {
      throw error
    } else {
      yield* put(actions.setDataState({dataState: {state: 'unloaded', error}}))
    }
  }
}

export const saga = function* () {
  yield* takeEvery(actions.getBodyAreas.type, getBodyAreasSaga)
}
